import { Theme, Grid, withStyles, IconButton, Dialog, DialogTitle, DialogContent, Button, DialogActions } from "@material-ui/core";
import { WithStyles } from "@material-ui/core/es";
import HighlightOff from '@material-ui/icons/Forward';
import * as React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { RaceTypeLabels, RaceStateLabels } from "src/EnumsLabels";
import googleMaps from "src/api/googleMaps";
import { Race, RaceState } from "src/api/model";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import RaceDataComponent from "src/components/race/RaceDataComponent";
import { ConfigData } from "src/config";
import { IStore } from "src/store";
import { RaceActions } from "src/store/race/race-actions";
import { IRaceStore } from "src/store/race/race-reducer";
import { mockTheme, bindActions, WithActions } from "src/utils/utils";

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
});

function getColorState(state : RaceState) {
    let c = "#000000";
    if (state===RaceState.CREATED){
        c = "#01579b";  
    }
    if (state===RaceState.ASSIGNED){
        c = "#ff9800";  
    }
    if (state===RaceState.IN_PROGRESS){
        c = "#2e7d32";  
    }
    const st: React.CSSProperties ={
        color: c,
        fontWeight: "bold"
    }
    return st;
}

const classesType = styles(mockTheme);

interface RacesListProps extends RouteComponentProps<{ id: string }>, WithStyles<keyof typeof classesType>, WithActions<RaceActions> {
  races: IRaceStore;
  config: ConfigData;
}

interface RaceListState {
    seleccionado?: Race,
    openDialog: boolean
}

class RacesList extends React.Component<RacesListProps, RaceListState> {

    columnData: ColumnDefinition[] = [
        {
            path: '',
            numeric: true,
            label: 'Acciones',
            draw: (cd, data) => this.openDialog(cd, data)
        },{
            path: "id",
            label: "#Id",
            draw: (cd: ColumnDefinition, value: Race) => (<div># {value.id}</div>)
        },
        {
            path: "type",
            label: "Tipo",
            draw: (cd: ColumnDefinition, value: Race) => (<div>{RaceTypeLabels[value.type]}</div>)
        }, {
            path: "owner.user.name",
            label: "Cliente"
        }, {
            path: "startDate",
            label: "Inicio",
            draw: (cd: ColumnDefinition, value: Race) => {
                return (<span>{value.startDate}</span>)
            },
        }, {
            path: "state",
            label: "Estado",
            draw: (cd: ColumnDefinition, value: Race) => (
            <div 
            style={getColorState(value.state)}
            >
            {RaceStateLabels[value.state]}
            </div>)
        },
        {
            path: "branch.name",
            label: "Sucursal"
        },
        {
            path: "pickDate",
            label: "Retiro de local",
            draw: (cd: ColumnDefinition, value: Race) => {
                if (value.pickDate){
                    return (<span>{value.pickDate}</span>)
                }
                return  (<span></span>)
            },
        },
        {
            path: "route.length",
            label: "Distancia",
            draw: (cd: ColumnDefinition, value: Race) => {
                if (value){
                    return (<span><NumberFormat value={(value.route.length || 0) / 1000}
                    suffix={'Km.'}
                    displayType={'text'}
                    decimalScale={4} /></span>)
                }
                return  (<span></span>)
            }
            
        }
    ];
    
    constructor(props: RacesListProps) {
        super(props);
        this.openDialog = this.openDialog.bind(this);
        this.updateState= this.updateState.bind(this);
        this.props.actions.fetchAll();
        this.state = {
            openDialog: false,
        };
    }

    updateState(id: number) {
        this.setState({
            seleccionado: this.props.races.all.data.filter((r: Race) => r.id === id)[0], 
            openDialog: true
        });
    }

    openDialog(cd: ColumnDefinition, data: Race) {
        return (
            <div>
                <IconButton aria-label='Ver mas' title='Ver' onClick={(e: any) => this.updateState(data.id)}>
                    <HighlightOff />
                </IconButton>
            </div>
        );
    }
  
    render() {
        console.info(this.props.races.all);
        return (<div>
        <Grid container spacing={24}>
            <Grid item sm={12} md={12}>
            <AsyncTable
                columnDefinition={this.columnData}
                showFiltro={true}
                title="Repartos realizados"
                data={this.props.races.all.data}
                defaultOrder={{
                    name: "branch",
                    direction: "asc",
                }}
            />
            </Grid>
        </Grid>
        {this.state.seleccionado && <Dialog open={this.state.openDialog} onClose={() => this.setState({openDialog: false})}>
            <DialogTitle>{"Informacion sobre el reparto N° " + this.state.seleccionado.id}</DialogTitle>
            <DialogContent>
                <RaceDataComponent race={this.state.seleccionado} rutaMapa={() => (this.state.seleccionado!.route && this.props.config) ? googleMaps.buildStaticImage(this.props.config.maps.key, this.state.seleccionado!.route.mapLine) : ""} />
            </DialogContent>
            <DialogActions>
                    <Button onClick={() => this.setState({openDialog: false})} color="secondary">
                        Cerrar
                    </Button>
            </DialogActions>
        </Dialog>}
        </div>);
    }
}

const mapStateToProps= (state: IStore, ownProps: RacesListProps) => ({
    ...ownProps,
    races: state.race,
    config: state.config.data
})

const styled= withStyles(styles as any)(RacesList);
const connected = connect(mapStateToProps, bindActions(RaceActions))(styled);
export default connected as React.ComponentClass<Partial<RacesListProps>>


// WEBPACK FOOTER //
// ./src/pages/racesList.tsx